import classNames from 'classnames';

export const Divider = ({
    className,
    ...props
}: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHRElement>,
    HTMLHRElement
>) => {
    return (
        <hr
            className={classNames(
                'my-l box-border flex w-full border-[0.5px] border-solid border-structure-80',
                className
            )}
            {...props}
        />
    );
};
